var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.833,
    height: 89.205,
    viewBox: "0 0 170.833 89.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(-671.277 -3328.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(671.277 3328.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11569",
    "data-name": "Path 11569",
    d: "M1205.833,791.033c-1.328-1.414-3.064-1.007-4.676-.974-1.1.023-1.556-.3-1.724-1.431-.351-2.36-.889-4.691-1.316-7.041a18.427,18.427,0,0,0-3.786-8.6,3.473,3.473,0,0,1-.662-1.949c-.084-2.046-.031-4.1-.031-6.3h-3.693c-.757-2.636-.4-7.121.739-8.381a6.5,6.5,0,0,0-1.046-.727c-.548.545-1.374,1.156-1.421,1.8-.169,2.318-.066,4.656-.066,7.107l-1.613.175-.215-2.982c-2.508-.089-.774,2.1-1.644,2.784-.962.594-2.867-.769-2.983,1.52-.557-.29-.717-.771-1.187-3.414h-5.649v-25.61h6.562c0-.9.006-1.643,0-2.39a1.573,1.573,0,0,0-1.749-1.761c-1.553-.009-3.107,0-4.762,0-.1-2.05-1.4-2.247-3.017-2.218-3.837.067-7.677.073-11.514-.005-1.639-.033-2.886.24-3.057,2.212h-21.768q-3,0-6.008,0c-2.634,0-2.862.24-2.8,2.885.008.326.039.651.07,1.153h5.689c-1.762,8.673-3.481,17.129-5.213,25.65l-2.72.125.256.445a11.478,11.478,0,0,1-2.26,1.7c-1.784.756-3.7,1.21-5.483,1.967a2.191,2.191,0,0,1-2.915-.584c-1.473-1.809-3.078-1.825-5.227-.986-5.169,2.014-10.454,3.734-15.714,5.508-1.146.386-1.687.88-1.627,2.2.122,2.644.026,2.621-2.46,3.519a36.423,36.423,0,0,0-4.779,1.92,10.846,10.846,0,0,0-5.013,5.814c-1.1,2.788-2.308,5.541-3.271,8.377a5.535,5.535,0,0,1-3.257,3.689,27.285,27.285,0,0,0-2.559,1.391,51.04,51.04,0,0,1-1.249-5.782,11.7,11.7,0,0,0-4.537-8.315c-1.57-1.279-2.751-3.036-4.327-4.428-1.6,2.468.716,4.015.794,6.108-4.563,3.557-9.319,7.037-13.806,10.836-3.539,3-7.27,5.194-12.134,4.963a3.774,3.774,0,0,0,2.755,3.229c6.369,2.129,12.7,4.373,19.022,6.647a6.766,6.766,0,0,0,4.671.263,6.731,6.731,0,0,1,4.719.061,4.4,4.4,0,0,0,2.457.27c2.036-.5,3.509.294,4.923,1.6a2.538,2.538,0,0,0,3.5.273c.558-.434,1.254-1.367,1.126-1.887-.474-1.927.812-2.969,1.738-4.2,2.2-2.932,4.442-5.839,6.739-8.851l1.167.466c.4-.5.789-.974,1.158-1.459,2.054-2.7,4.17-5.355,6.122-8.126a5.393,5.393,0,0,1,3.627-2.345c1.291-.248,2.544-.691,3.835-1.055.533,1.457.127,2.2-1.122,2.928a19.883,19.883,0,0,0-10.226,16.059c-.041.43-.005.866-.005,1.505h3.81c.311-5.464,2.4-9.959,6.815-13.191a15.764,15.764,0,0,1,10.335-3.106c6.742.337,14.778,5.03,15.659,16.2h3.837l-.3-3.861h26l-.3,3.826h3.922a16.505,16.505,0,0,1,5.787-12.274,15.712,15.712,0,0,1,10.4-3.9,15.9,15.9,0,0,1,11.6,4.682,16.391,16.391,0,0,1,4.9,11.539h3.9l-.251-4.011h4.716l-.41-2.716,4.219-1.534Zm-45.061-21.754h-26.454v-6.719h-3.762c1.759-8.648,3.48-17.105,5.186-25.5h31.619V762.68h-6.589Zm8.8-6.65v-25.7l1.864.088v25.531Zm-5.078,12.851H1184.8l-.08,1.671h-20.226Zm.094,6.507v-1.673h20.093v1.673Zm-52.16-14.32-.012.7-18.1,6.263c-.478-1.29.14-1.661,1.042-1.972,4.979-1.712,9.935-3.491,14.927-5.159A5.752,5.752,0,0,1,1112.425,767.667Zm-21.943,18.6a2.407,2.407,0,0,1,.032-4.813,2.407,2.407,0,1,1-.032,4.813Zm-21.289,16.614c1.295.135,2,.84,1.924,2.077a1.79,1.79,0,0,1-2.1,1.826,1.755,1.755,0,0,1-1.785-1.964C1067.24,803.529,1068.029,802.975,1069.193,802.885Zm15.93-5.77-8.69,11.432C1076.1,807.368,1082.917,798.211,1085.123,797.115Z",
    transform: "translate(-1035 -730.636)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11570",
    "data-name": "Path 11570",
    d: "M1069.4,817.242a13.444,13.444,0,1,0,13.453,13.126A13.5,13.5,0,0,0,1069.4,817.242Zm7.521,13.375a7.531,7.531,0,0,1-15.06.168,7.531,7.531,0,1,1,15.06-.168Z",
    transform: "translate(-927.07 -754.924)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11571",
    "data-name": "Path 11571",
    d: "M1147.575,830.566a13.425,13.425,0,1,0,13.556-13.325A13.471,13.471,0,0,0,1147.575,830.566Zm5.921.017a7.479,7.479,0,0,1,7.573-7.462,7.52,7.52,0,1,1-.153,15.039A7.377,7.377,0,0,1,1153.5,830.583Z",
    transform: "translate(-1084.597 -754.924)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11572",
    "data-name": "Path 11572",
    d: "M1118.682,771.784v-6.6h6.589V739.569h-31.619l-5.187,25.5h3.762v6.719Z",
    transform: "translate(-992.91 -733.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11573",
    "data-name": "Path 11573",
    d: "M1082.808,765.081l1.864-.082V739.468l-1.864-.088Z",
    transform: "translate(-948.239 -733.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11574",
    "data-name": "Path 11574",
    d: "M1064.235,792.958v1.671h20.226l.08-1.671Z",
    transform: "translate(-934.744 -748.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11575",
    "data-name": "Path 11575",
    d: "M1064.4,801.349h20.093v-1.673H1064.4Z",
    transform: "translate(-934.815 -749.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11576",
    "data-name": "Path 11576",
    d: "M1183.086,782.008a5.751,5.751,0,0,0-2.138-.165c-4.992,1.669-9.948,3.447-14.927,5.159-.9.31-1.52.681-1.042,1.972l18.1-6.263Z",
    transform: "translate(-1105.66 -744.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11577",
    "data-name": "Path 11577",
    d: "M1194.209,806.079a2.407,2.407,0,1,0,.032-4.813,2.407,2.407,0,0,0-.032,4.813Z",
    transform: "translate(-1138.726 -750.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11578",
    "data-name": "Path 11578",
    d: "M1224.175,831.044c-1.164.09-1.953.644-1.962,1.94a1.756,1.756,0,0,0,1.785,1.964,1.79,1.79,0,0,0,2.1-1.826C1226.175,831.884,1225.469,831.179,1224.175,831.044Z",
    transform: "translate(-1189.982 -758.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11579",
    "data-name": "Path 11579",
    d: "M1211.459,823.025c-2.206,1.1-9.027,10.253-8.69,11.432Z",
    transform: "translate(-1161.337 -756.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11580",
    "data-name": "Path 11580",
    d: "M1070.694,834.748a2.933,2.933,0,0,0,2.837,2.884,2.865,2.865,0,0,0,2.837-2.849,2.9,2.9,0,0,0-2.806-2.9A2.972,2.972,0,0,0,1070.694,834.748Z",
    transform: "translate(-931.219 -759.031)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11581",
    "data-name": "Path 11581",
    d: "M1162.242,834.667a2.937,2.937,0,0,0,2.772,2.959,2.97,2.97,0,0,0,2.973-2.764,3.023,3.023,0,0,0-2.783-2.975A2.989,2.989,0,0,0,1162.242,834.667Z",
    transform: "translate(-1088.711 -759.031)",
    fill: "#F26A1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle5);
export default __webpack_public_path__ + "static/media/vehicle-5.da31c0263209f3ffd2536f813b3b90ce.svg";
export { ForwardRef as ReactComponent };